import { BaseEntity } from '../base-entity';

export class FormCamisaTrieurFilter extends BaseEntity {
    safra?: string;
    site?: string;
    hibrido_rnc?: string;
    responsavel_lancamento?: string;
}
